import Link from './Link';

const ButtonLink = ({ href, text }) => (
  <Link href={href} className="css-aqtsjn">
    {text}
  </Link>
);

export default ButtonLink;
